/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { Link, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import {API_UPLOADS} from "../../api";
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Redux]
-------------------------------------------------------------------*/
import {useSelector, useDispatch} from 'react-redux';
import { _action_user } from '../../redux/store';
/*------------------------------------------------------------------
[End Redux]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Style]
-------------------------------------------------------------------*/
import '../../style/components/node.components.css';
/*------------------------------------------------------------------
[End Style]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import {decode} from 'html-entities';
import {reactLocalStorage} from 'reactjs-localstorage';
import { convertDateDBtoIndo, MONTH, TODAY, YEAR } from "../../functions";
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

const Screen = ({ pages, profile, setting, contact, about, footer, location }) => {

	let STORAGE_USER = reactLocalStorage.get('@user');

	let STORAGE_GUEST_USER = reactLocalStorage.get('@guest_user');

	const [profile_active, set_profile_active] = useState(false);
	const [profile_url, set_profile_url] = useState('');

	const [information_active, set_information_active] = useState(false);
	const [information_url, set_information_url] = useState('');

	const [about_active, set_about_active] = useState(false);
	const [about_url, set_about_url] = useState('');
	
	//#region redux ------------------------------------------------

	const dispatch = useDispatch();

    const redux_user = useSelector(state => state.user);

	const _set_redux_user = (data) => {
		dispatch(_action_user(data, 'data'))
	}

	//#endregion redux ---------------------------------------------

	useEffect(() => {
        
        if(STORAGE_USER === undefined){
            _set_redux_user('')
        }else{
            _set_redux_user(JSON.parse(STORAGE_USER))
        }

    }, [])

	return (
		<>
			<div className="i-nav-small-container">
				<div className="_container">
					<div className="_row _center_align">
						<div className="_text_overflow">
							{convertDateDBtoIndo(YEAR + '-' + MONTH + '-' + TODAY)}
						</div>
						<div className="_column"></div>
						<div className="_push_r_m">
							<div className="_row _center_align" style={{margin: 0}}>
								<div className="_push_r_s __cl_text_main">
									<ion-icon name="call-outline" style={{marginBottom: -4, fontSize: 18}}></ion-icon>
								</div>
								<div className="_column">
									{
										footer && footer[0].phone
									}
								</div>
							</div>
						</div>
						<div>
							<div className="_row _center_align" style={{margin: 0}}>
								<div className="_push_r_s __cl_text_main">
									<ion-icon name="mail-outline" style={{marginBottom: -4, fontSize: 18}}></ion-icon>
								</div>
								<div className="_column">
									{
										footer && footer[0].email
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="i-nav-container">
				<nav className="i-nav" id="iNav">
					<div className="_container">
						<label htmlFor="iMobile" id="iToggle">
							<strong>
								{
									setting.logo &&
									<img width="32" style={{marginLeft: 0}} src={API_UPLOADS + setting.logo} alt="logo" />
								}
							</strong>
							<span className="i-drop-icon">
								<i className="i-hamburger"></i>
							</span>
						</label>

						<input type="checkbox" id="iMobile" />

						<ul className="i-main-nav">
							<li className="i-nav-right">
								<NavLink 
									to='/register'
									className="i-nav-right-login"
									activeClassName="__nav_active_background"
									// onClick={() => location('guest')}
								>
									Register
								</NavLink>
							</li>
							<li className="i-nav-right">
								<NavLink 
									to='/login'
									className="i-nav-right-border"
									activeClassName="__nav_active"
								>
									Login
								</NavLink>
							</li>

							{/* <li className="i-nav-right">
								<NavLink 
									to='/guest'
									activeClassName="__nav_active"
								>
									Guest
								</NavLink>
							</li>

							<li className="i-nav-right"><a style={{color : about_active ? '#000' : '#555'}}>Tentang
									<span className="i-drop-icon">
										<i className="i-arrow-down"></i>
									</span>
								</a>
								<label className="i-drop-icon" htmlFor="iDropdown3">
									<i className="i-arrow-down i-arrow-down-mobile"></i>
								</label>

								<input type="checkbox" id="iDropdown3" />

								<ul className="i-dropdown">
									<li>
										{
											about&&
											<NavLink 
												to={{
													pathname: "/pages/" + about[0].slug,
													hash: "#about",
												}}
												isActive={(match, location) => {
													if(location.hash !== '#about'){
														set_about_active(false)
														set_about_url('')
													}else{
														set_about_active(true)
														set_about_url(location.pathname)
													}
												}}
											>
												<span 
													style={{
														color: about_url === '/pages/' + about[0].slug ? '#000' : '#555'
													}}>
													Tentang Kami
												</span>
											</NavLink>
										}
									</li>
									<li>
										{
											contact&&
											<NavLink 
												to={{
													pathname: "/pages/" + contact[0].slug,
													hash: "#about",
												}}
												isActive={(match, location) => {
													if(location.hash !== '#about'){
														set_about_active(false)
														set_about_url('')
													}else{
														set_about_active(true)
														set_about_url(location.pathname)
													}
												}}
											>
												<span 
													style={{
														color: about_url === '/pages/' + contact[0].slug ? '#000' : '#555'
													}}>
													Kontak
												</span>
											</NavLink>
										}
									</li>
								</ul>
							</li>
							
							<li className="i-nav-right"><a style={{color : information_active ? '#000' : '#555'}}>Informasi
									<span className="i-drop-icon">
										<i className="i-arrow-down"></i>
									</span>
								</a>
								<label className="i-drop-icon" htmlFor="iDropdown2">
									<i className="i-arrow-down i-arrow-down-mobile"></i>
								</label>

								<input type="checkbox" id="iDropdown2" />

								<ul className="i-dropdown">
									<li>
										<NavLink 
											to={{
												pathname: "/bulletin",
												hash: "#information",
											}}
											isActive={(match, location) => {
												if(location.hash !== '#information'){
													set_information_active(false)
													set_information_url('')
												}else{
													set_information_active(true)
													set_information_url(location.pathname)
												}
											}}
										>
											<span 
												style={{
													color: '#555'
												}}>
												Pengumuman
											</span>
										</NavLink>
									</li>
									<li>
										<NavLink 
											to={{
												pathname: "/news",
												hash: "#information",
											}}
											isActive={(match, location) => {
												if(location.hash !== '#information'){
													set_information_active(false)
													set_information_url('')
												}else{
													set_information_active(true)
													set_information_url(location.pathname)
												}
											}}
										>
											<span 
												style={{
													color: '#555'
												}}>
												Berita
											</span>
										</NavLink>
									</li>
									<li>
										<NavLink 
											to={{
												pathname: "/event",
												hash: "#information",
											}}
											isActive={(match, location) => {
												if(location.hash !== '#information'){
													set_information_active(false)
													set_information_url('')
												}else{
													set_information_active(true)
													set_information_url(location.pathname)
												}
											}}
										>
											<span 
												style={{
													color: '#555'
												}}>
												Kegiatan
											</span>
										</NavLink>
									</li>
									<li>
										<NavLink 
											to={{
												pathname: "/article",
												hash: "#information",
											}}
											isActive={(match, location) => {
												if(location.hash !== '#information'){
													set_information_active(false)
													set_information_url('')
												}else{
													set_information_active(true)
													set_information_url(location.pathname)
												}
											}}
										>
											<span 
												style={{
													color: '#555'
												}}>
												Article
											</span>
										</NavLink>
									</li>
								</ul>
							</li> */}

							<li className="i-nav-right">
								<NavLink to="/gallery" activeClassName="__nav_active">
									Gallery
								</NavLink>
							</li>

							<li className="i-nav-logo _relative">
								<Link to="/"> 
									{
										setting.logo &&
										<div style={{marginLeft: -20}}>
											<img width="32" style={{marginLeft: 0, marginTop: -6}} src={API_UPLOADS + setting.logo} alt="logo" />
										</div>
									}
								</Link>
							</li>

							<li>
								<NavLink exact to="/home" activeClassName="__nav_active">
									Home
								</NavLink>
							</li>
							<li><a style={{color : profile_active ? '#000' : '#555'}}>Profile
									<span className="i-drop-icon">
										<i className="i-arrow-down"></i>
									</span>
								</a>
								<label className="i-drop-icon" htmlFor="iDropdown1">
									<i className="i-arrow-down i-arrow-down-mobile"></i>
								</label>

								<input type="checkbox" id="iDropdown1" />

								<ul className="i-dropdown">
									{
										profile&&profile.map((item, index) => (
											<li key={index}>
												<NavLink 
													to={{
														pathname: "/pages/" + item.slug,
														hash: "#profile",
													}}
													isActive={(match, location) => {
														if(location.hash !== '#profile'){
															set_profile_active(false)
															set_profile_url('')
														}else{
															set_profile_active(true)
															set_profile_url(location.pathname)
														}
													}}
												>
													<span 
														style={{
															color: profile_url === '/pages/' + item.slug ? '#000' : '#555'
														}}>
														{decode(item.title)}
													</span>
												</NavLink>
											</li>
										))
									}
								</ul>
							</li>

							<div className="i-nav-link-pages">
								{
									pages&&pages.map((item, index) => (
										<li key={index}>
											<NavLink 
												to={{
													pathname: "/pages/" + item.slug,
												}}
												activeClassName="__nav_active"
											>
												{item.title}
											</NavLink>
										</li>
									))
								}
							</div>
						</ul>
					</div>
				</nav>
			</div>
		</>
	);
}

export default Screen;